import React, { useEffect, useState } from 'react'

import { AudioLevelIndicator } from '../../../../RoomUI/components/AudioLevelIndicator/AudioLevelIndicator'
import { logMessage } from '../../../../Logging/log'

interface VideoPreviewProps {
  deviceId: string
}

const AudioPreview = ({ deviceId }: VideoPreviewProps) => {
  const [audioTrack, setAudioTrack] = useState<MediaStreamTrack | undefined>(
    undefined
  )

  useEffect(() => {
    if (!deviceId) {
      setAudioTrack(undefined)
      return undefined
    }

    let cancelled = false
    let previewStream: MediaStream | undefined

    navigator.mediaDevices
      .getUserMedia({
        audio: { deviceId: { exact: deviceId } },
      })
      .then((mediaStream) => {
        if (cancelled) {
          mediaStream.getTracks().forEach((track) => track.stop())
          return
        }
        previewStream = mediaStream
        setAudioTrack(mediaStream.getAudioTracks()[0])
      })
      .catch((error: unknown) => {
        logMessage(
          'Issue occurred while previewing audio in device selector.',
          {
            level: 'warning',
            extra: { deviceId, cause: error },
          }
        )
      })

    return () => {
      cancelled = true
      previewStream?.getTracks().forEach((track) => track.stop())
    }
  }, [deviceId])

  return <AudioLevelIndicator audioTrack={audioTrack} enabled />
}

export { AudioPreview }
